import React, { useEffect, useRef, useState, useCallback } from 'react';

// Use REACT_APP_API_URL env var so production builds point to the real backend.
// Set in admin/.env.production → REACT_APP_API_URL=https://api.eazyworldehsengineering.com
const API = process.env.REACT_APP_API_URL || 'https://api.eazyworldehsengineering.com';
const PAGES = ['home', 'about', 'services', 'training', 'clients', 'products', 'contact'];
// Use REACT_APP_FRONTEND_URL so static images are served from the correct frontend host.
// Set in admin/.env.production → REACT_APP_FRONTEND_URL=https://eazyworldehsengineering.com
const FRONTEND = process.env.REACT_APP_FRONTEND_URL || 'http://localhost:3000';

const STATIC_IMAGES = {
  home:     ['/images/home.jpeg', ...Array.from({ length: 13 }, (_, i) => `/images/home${i + 1}.jpeg`)],
  about:    Array.from({ length: 13 }, (_, i) => `/images/About${i + 1}.jpeg`),
  services: ['/images/services.jpeg', ...Array.from({ length: 11 }, (_, i) => `/images/services${i + 1}.jpeg`)],
  training: Array.from({ length: 12 }, (_, i) => `/images/train${i + 1}.jpeg`),
  clients:  [],
  products: [],
  contact:  [],
};

/* ── Shared styles ─────────────────────────────────────────────────────────── */
const c = {
  wrap:    { minHeight: '100vh', background: '#F8F9FA', fontFamily: 'Outfit, sans-serif', color: '#111827', padding: '2rem' },
  header:  { display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '1rem', marginBottom: '2.5rem', borderBottom: '1px solid rgba(0,0,0,0.08)', paddingBottom: '1.5rem' },
  brand:   { display: 'flex', alignItems: 'center', gap: '0.9rem' },
  logo:    { height: '64px', width: 'auto', objectFit: 'contain', flexShrink: 0, maxWidth: '80px', filter: 'drop-shadow(0 1px 3px rgba(0,0,0,0.12))' },
  brandName: { lineHeight: 1.2 },
  brandTitle: { margin: 0, fontFamily: 'Outfit, sans-serif', fontWeight: 900, fontSize: '1.35rem', letterSpacing: '0.5px', color: '#E8500A', textTransform: 'uppercase' },
  brandSub:   { margin: 0, fontFamily: 'Outfit, sans-serif', fontWeight: 600, fontSize: '0.75rem', letterSpacing: '2px', color: '#374151', textTransform: 'uppercase' },
  nav:     { display: 'flex', gap: '0.5rem', marginBottom: '2rem' },
  navBtn:  (active) => ({ padding: '0.6rem 1.4rem', borderRadius: '10px', cursor: 'pointer', fontFamily: 'Outfit, sans-serif', fontWeight: 700, fontSize: '0.85rem', letterSpacing: '0.5px', transition: 'all 0.2s', background: active ? 'linear-gradient(135deg,#E8500A,#FF6A00)' : '#FFFFFF', color: active ? '#fff' : '#6B7280', border: active ? 'none' : '1px solid #E5E7EB' }),
  card:    { background: '#FFFFFF', border: '1px solid #E5E7EB', borderRadius: '16px', padding: '1.75rem', marginBottom: '1.5rem', boxShadow: '0 1px 3px rgba(0,0,0,0.06), 0 4px 16px rgba(0,0,0,0.04)' },
  label:   { display: 'block', color: '#6B7280', fontSize: '0.7rem', letterSpacing: '2px', textTransform: 'uppercase', marginBottom: '0.45rem' },
  input:   { width: '100%', background: '#F9FAFB', border: '1px solid #E5E7EB', borderRadius: '10px', padding: '0.7rem 1rem', color: '#111827', fontSize: '0.95rem', fontFamily: 'Outfit, sans-serif', outline: 'none', boxSizing: 'border-box', marginBottom: '1.1rem' },
  select:  { width: '100%', background: '#F9FAFB', border: '1px solid #E5E7EB', borderRadius: '10px', padding: '0.7rem 1rem', color: '#111827', fontSize: '0.95rem', fontFamily: 'Outfit, sans-serif', outline: 'none', boxSizing: 'border-box', marginBottom: '1.1rem', cursor: 'pointer' },
  btn:     (variant = 'primary') => ({ padding: '0.7rem 1.4rem', borderRadius: '10px', cursor: 'pointer', fontFamily: 'Outfit, sans-serif', fontWeight: 700, fontSize: '0.85rem', transition: 'opacity 0.2s', background: variant === 'primary' ? 'linear-gradient(135deg,#E8500A,#FF6A00)' : variant === 'danger' ? 'rgba(220,38,38,0.08)' : '#F3F4F6', color: variant === 'danger' ? '#DC2626' : variant === 'primary' ? '#fff' : '#374151', border: variant === 'danger' ? '1px solid rgba(220,38,38,0.2)' : variant === 'ghost' ? '1px solid #E5E7EB' : 'none' }),
  toast:   (ok) => ({ padding: '0.6rem 1rem', borderRadius: '8px', fontSize: '0.82rem', textAlign: 'center', background: ok ? 'rgba(34,197,94,0.08)' : 'rgba(232,80,10,0.08)', color: ok ? '#16A34A' : '#E8500A', border: `1px solid ${ok ? 'rgba(34,197,94,0.2)' : 'rgba(232,80,10,0.2)'}`, marginTop: '0.75rem' }),
  divider: { height: '1px', background: '#E5E7EB', margin: '1.25rem 0' },
  grid:    { display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(160px, 1fr))', gap: '0.75rem', marginTop: '1rem' },
  imgCard: (dragging) => ({ position: 'relative', borderRadius: '10px', overflow: 'hidden', border: dragging ? '2px solid #E8500A' : '1px solid #E5E7EB', background: '#F9FAFB', cursor: 'grab', opacity: dragging ? 0.5 : 1, transition: 'border-color 0.2s' }),
  imgEl:   { width: '100%', height: '110px', objectFit: 'cover', display: 'block' },
  imgOver: { position: 'absolute', inset: 0, background: 'rgba(0,0,0,0.45)', display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: '0.4rem', opacity: 0, transition: 'opacity 0.2s' },
  tag:     { fontSize: '0.65rem', color: '#6B7280', padding: '0.25rem 0.5rem', textAlign: 'center', background: '#F3F4F6' },
  pageTab: (active) => ({ padding: '0.45rem 1rem', borderRadius: '8px', cursor: 'pointer', fontFamily: 'Outfit, sans-serif', fontWeight: 600, fontSize: '0.8rem', background: active ? 'rgba(232,80,10,0.08)' : 'transparent', color: active ? '#E8500A' : '#6B7280', border: active ? '1px solid rgba(232,80,10,0.25)' : '1px solid transparent', transition: 'all 0.15s' }),
};

/* ── Toast helper ──────────────────────────────────────────────────────────── */
function Toast({ msg, ok }) {
  if (!msg) return null;
  return <div style={c.toast(ok)}>{msg}</div>;
}

/* ══════════════════════════════════════════════════════════════════════════════
   STATS PANEL
══════════════════════════════════════════════════════════════════════════════ */
function StatsPanel() {
  const [form, setForm] = useState({ participants_trained: '', batches_delivered: '' });
  const [toast, setToast] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    fetch(`${API}/api/stats`).then(r => r.json()).then(d => setForm(d)).catch(() => {});
  }, []);

  const save = async () => {
    setLoading(true);
    try {
      const res = await fetch(`${API}/api/stats`, { method: 'PUT', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(form) });
      setToast({ ok: res.ok, msg: res.ok ? '✓ Stats updated successfully.' : '✗ Failed to save.' });
    } catch { setToast({ ok: false, msg: '✗ Backend unreachable.' }); }
    finally { setLoading(false); setTimeout(() => setToast(null), 3000); }
  };

  return (
    <div style={{ maxWidth: 480 }}>
      <div style={c.card}>
        <label style={c.label}>Participants Trained</label>
        <input style={c.input} value={form.participants_trained} onChange={e => setForm(f => ({ ...f, participants_trained: e.target.value }))} placeholder="e.g. 46,471+" />
        <label style={c.label}>Batches Delivered</label>
        <input style={c.input} value={form.batches_delivered} onChange={e => setForm(f => ({ ...f, batches_delivered: e.target.value }))} placeholder="e.g. 10,628+" />
        <div style={c.divider} />
        <button style={{ ...c.btn('primary'), width: '100%', padding: '0.85rem', opacity: loading ? 0.6 : 1 }} onClick={save} disabled={loading}>
          {loading ? 'Saving…' : 'Save Changes'}
        </button>
        {toast && <Toast msg={toast.msg} ok={toast.ok} />}
      </div>
    </div>
  );
}

/* ══════════════════════════════════════════════════════════════════════════════
   INSPECTION / AUDIT REQUESTS PANEL
══════════════════════════════════════════════════════════════════════════════ */
const STATUS_OPTIONS = ['new', 'reviewed', 'scheduled', 'closed'];
const STATUS_COLOR = { new: '#E8500A', reviewed: '#2563EB', scheduled: '#16A34A', closed: '#6B7280' };

function InspectionsPanel() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [toast, setToast] = useState(null);
  const [expanded, setExpanded] = useState(null);

  const showToast = (msg, ok = true) => { setToast({ msg, ok }); setTimeout(() => setToast(null), 3000); };

  const load = useCallback(() => {
    setLoading(true);
    fetch(`${API}/api/inspections`)
      .then(r => r.json())
      .then(setItems)
      .catch(() => showToast('✗ Could not load submissions.', false))
      .finally(() => setLoading(false));
  }, []);

  useEffect(() => { load(); }, [load]);

  const changeStatus = async (id, status) => {
    await fetch(`${API}/api/inspections/${id}/status`, {
      method: 'PUT', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ status }),
    });
    setItems(list => list.map(it => it.id === id ? { ...it, status } : it));
  };

  const remove = async (id) => {
    if (!window.confirm('Delete this submission?')) return;
    await fetch(`${API}/api/inspections/${id}`, { method: 'DELETE' });
    setItems(list => list.filter(it => it.id !== id));
    showToast('✓ Submission deleted.');
  };

  const fmtDate = (iso) => {
    try { return new Date(iso).toLocaleString(); } catch { return iso; }
  };

  return (
    <div>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '1rem' }}>
        <div style={{ color: '#6B7280', fontSize: '0.85rem' }}>
          {loading ? 'Loading…' : `${items.length} submission${items.length !== 1 ? 's' : ''}`}
        </div>
        <button style={c.btn('ghost')} onClick={load}>↻ Refresh</button>
      </div>

      {toast && <Toast msg={toast.msg} ok={toast.ok} />}

      {!loading && items.length === 0 && (
        <div style={{ ...c.card, textAlign: 'center', color: '#6B7280', fontSize: '0.9rem' }}>
          No inspection or audit requests have been submitted yet.
        </div>
      )}

      {items.map(item => {
        const isOpen = expanded === item.id;
        return (
          <div key={item.id} style={c.card}>
            <div
              style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '1rem', cursor: 'pointer', flexWrap: 'wrap' }}
              onClick={() => setExpanded(isOpen ? null : item.id)}
            >
              <div>
                <div style={{ fontWeight: 700, fontSize: '1rem' }}>
                  {item.first_name} {item.last_name}
                  {item.company && <span style={{ color: '#6B7280', fontWeight: 500 }}> — {item.company}</span>}
                </div>
                <div style={{ color: '#6B7280', fontSize: '0.8rem', marginTop: '0.2rem' }}>
                  {item.scope || 'No scope specified'} · Submitted {fmtDate(item.submitted_at)}
                </div>
              </div>
              <span style={{
                fontSize: '0.7rem', fontWeight: 700, letterSpacing: '1px', textTransform: 'uppercase',
                padding: '0.3rem 0.7rem', borderRadius: '999px',
                color: STATUS_COLOR[item.status] || '#6B7280',
                background: `${STATUS_COLOR[item.status] || '#6B7280'}14`,
                border: `1px solid ${STATUS_COLOR[item.status] || '#6B7280'}33`,
              }}>
                {item.status}
              </span>
            </div>

            {isOpen && (
              <>
                <div style={c.divider} />
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: '1rem', fontSize: '0.88rem' }}>
                  <div><div style={c.label}>Email</div><a href={`mailto:${item.email}`}>{item.email}</a></div>
                  <div><div style={c.label}>Phone</div><a href={`tel:${item.phone}`}>{item.phone}</a></div>
                  <div><div style={c.label}>Company</div>{item.company || '—'}</div>
                  <div><div style={c.label}>Service Scope</div>{item.scope || '—'}</div>
                </div>
                <div style={{ marginTop: '1rem' }}>
                  <div style={c.label}>Scope / Inspection Details</div>
                  <p style={{ margin: 0, whiteSpace: 'pre-wrap', color: '#374151' }}>{item.details || '—'}</p>
                </div>
                <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem', marginTop: '1.25rem', flexWrap: 'wrap' }}>
                  <div style={c.label}>Update status</div>
                  <select
                    style={{ ...c.select, width: 'auto', marginBottom: 0 }}
                    value={item.status}
                    onChange={e => changeStatus(item.id, e.target.value)}
                  >
                    {STATUS_OPTIONS.map(s => <option key={s} value={s}>{s}</option>)}
                  </select>
                  <button style={c.btn('danger')} onClick={() => remove(item.id)}>Delete</button>
                </div>
              </>
            )}
          </div>
        );
      })}
    </div>
  );
}

/* ══════════════════════════════════════════════════════════════════════════════
   IMAGE MANAGEMENT PANEL
══════════════════════════════════════════════════════════════════════════════ */
function ImagePanel() {
  const [activePage, setActivePage] = useState('home');
  const [images, setImages] = useState([]);       // [{filename, url}]
  const [toast, setToast] = useState(null);
  const [uploading, setUploading] = useState(false);
  const [seeding, setSeeding] = useState(false);
  const [uploadPage, setUploadPage] = useState('home');
  const uploadRef = useRef();
  const replaceRef = useRef();
  const replaceTarget = useRef(null);
  const dragSrc = useRef(null);

  const showToast = (msg, ok = true) => { setToast({ msg, ok }); setTimeout(() => setToast(null), 3000); };

  const loadImages = useCallback((page) => {
    fetch(`${API}/api/images/${page}`)
      .then(r => r.json())
      .then(urls => setImages(urls.map(u => ({ filename: u.split('/').pop(), url: `${API}${u}` }))))
      .catch(() => showToast('✗ Could not load images.', false));
  }, []);

  useEffect(() => { loadImages(activePage); }, [activePage, loadImages]);

  /* Upload */
  const handleUpload = async (e) => {
    const files = Array.from(e.target.files);
    if (!files.length) return;
    setUploading(true);
    let ok = 0;
    for (const file of files) {
      const fd = new FormData();
      fd.append('image', file);
      const res = await fetch(`${API}/api/images/${uploadPage}`, { method: 'POST', body: fd });
      if (res.ok) ok++;
    }
    setUploading(false);
    uploadRef.current.value = '';
    showToast(`✓ ${ok}/${files.length} image(s) uploaded to "${uploadPage}".`);
    if (uploadPage === activePage) loadImages(activePage);
  };

  /* Delete */
  const handleDelete = async (filename) => {
    if (!window.confirm(`Delete "${filename}"?`)) return;
    await fetch(`${API}/api/images/${activePage}/${filename}`, { method: 'DELETE' });
    showToast('✓ Image deleted.');
    loadImages(activePage);
  };

  /* Replace */
  const triggerReplace = (filename) => { replaceTarget.current = filename; replaceRef.current.click(); };
  const handleReplace = async (e) => {
    const file = e.target.files[0];
    if (!file || !replaceTarget.current) return;
    const fd = new FormData();
    fd.append('image', file);
    const res = await fetch(`${API}/api/images/${activePage}/${replaceTarget.current}`, { method: 'PUT', body: fd });
    replaceRef.current.value = '';
    showToast(res.ok ? '✓ Image replaced.' : '✗ Replace failed.', res.ok);
    loadImages(activePage);
  };

  /* Drag-to-reorder */
  const onDragStart = (i) => { dragSrc.current = i; };
  const onDrop = async (i) => {
    if (dragSrc.current === null || dragSrc.current === i) return;
    const next = [...images];
    const [moved] = next.splice(dragSrc.current, 1);
    next.splice(i, 0, moved);
    setImages(next);
    dragSrc.current = null;
    await fetch(`${API}/api/images/${activePage}/order`, {
      method: 'PUT', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(next.map(img => img.filename)),
    });
    showToast('✓ Order saved.');
  };

  /* Seed from public/images */
  const handleSeed = async () => {
    setSeeding(true);
    const res = await fetch(`${API}/api/images/${activePage}/seed`, { method: 'POST' });
    const data = await res.json();
    setSeeding(false);
    showToast(data.seeded?.length ? `✓ Imported ${data.seeded.length} image(s) from public folder.` : '✓ No new images to import (already up to date).');
    loadImages(activePage);
  };

  /* Delete static image: seed page first so backend tracks it, then delete */
  const handleDeleteStatic = async (path) => {
    const filename = path.split('/').pop();
    if (!window.confirm(`Delete "${filename}" from ${activePage}?`)) return;
    // seed so backend knows about all static images
    await fetch(`${API}/api/images/${activePage}/seed`, { method: 'POST' });
    await fetch(`${API}/api/images/${activePage}/${filename}`, { method: 'DELETE' });
    showToast(`✓ "${filename}" deleted.`);
    loadImages(activePage);
  };

  return (
    <div>
      {/* ── Upload card ── */}
      <div style={c.card}>
        <div style={{ display: 'flex', alignItems: 'flex-end', gap: '1rem', flexWrap: 'wrap' }}>
          <div style={{ flex: 1, minWidth: 160 }}>
            <label style={c.label}>Target Page</label>
            <select style={{ ...c.select, marginBottom: 0 }} value={uploadPage} onChange={e => setUploadPage(e.target.value)}>
              {PAGES.map(p => <option key={p} value={p}>{p.charAt(0).toUpperCase() + p.slice(1)}</option>)}
            </select>
          </div>
          <div style={{ flex: 2, minWidth: 200 }}>
            <label style={c.label}>Images (multi-select supported)</label>
            <input ref={uploadRef} type="file" accept="image/*" multiple onChange={handleUpload} style={{ display: 'none' }} />
            <button style={{ ...c.btn('primary'), width: '100%', opacity: uploading ? 0.6 : 1 }} onClick={() => uploadRef.current.click()} disabled={uploading}>
              {uploading ? 'Uploading…' : '+ Upload Images'}
            </button>
          </div>
        </div>
        {toast && <Toast msg={toast.msg} ok={toast.ok} />}
      </div>

      {/* ── Page tabs + gallery ── */}
      <div style={c.card}>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: '0.75rem', marginBottom: '1rem' }}>
          <div style={{ display: 'flex', gap: '0.4rem', flexWrap: 'wrap' }}>
            {PAGES.map(p => (
              <button key={p} style={c.pageTab(activePage === p)} onClick={() => setActivePage(p)}>
                {p.charAt(0).toUpperCase() + p.slice(1)}
              </button>
            ))}
          </div>
          <button style={{ ...c.btn('ghost'), fontSize: '0.78rem', opacity: seeding ? 0.6 : 1 }} onClick={handleSeed} disabled={seeding} title="Copy existing images from public/images/ into the uploads folder">
            {seeding ? 'Importing…' : '⬇ Import from Public Folder'}
          </button>
        </div>

        <div style={{ color: '#6B7280', fontSize: '0.78rem', marginBottom: '0.5rem' }}>
          {images.length} image{images.length !== 1 ? 's' : ''} · Drag to reorder · Hover for actions
        </div>

        {/* Hidden replace input */}
        <input ref={replaceRef} type="file" accept="image/*" onChange={handleReplace} style={{ display: 'none' }} />

        {images.length === 0 ? (
          <div style={{ textAlign: 'center', padding: '3rem 1rem', color: '#6B7280', fontSize: '0.9rem', border: '1px dashed #D1D5DB', borderRadius: '10px' }}>
            No images yet. Upload some above, or click "Import from Public Folder".
          </div>
        ) : (
          <div style={c.grid}>
            {images.map((img, i) => (
              <ImageCard
                key={img.url}
                img={img}
                index={i}
                onDelete={() => handleDelete(img.filename)}
                onReplace={() => triggerReplace(img.filename)}
                onDragStart={() => onDragStart(i)}
                onDrop={() => onDrop(i)}
              />
            ))}
          </div>
        )}

        {/* ── Static images section (shown when backend has no managed images) ── */}
        {images.length === 0 && (STATIC_IMAGES[activePage] || []).length > 0 && (
          <>
            <div style={{ ...c.divider, marginTop: '1.5rem' }} />
            <div style={{ color: '#6B7280', fontSize: '0.75rem', letterSpacing: '1.5px', textTransform: 'uppercase', marginBottom: '0.75rem' }}>
              Existing Static Images — not yet managed
            </div>
            <div style={c.grid}>
              {(STATIC_IMAGES[activePage] || []).map((path, i) => (
                <StaticImageCard
                  key={path}
                  path={path}
                  index={i}
                  onDelete={() => handleDeleteStatic(path)}
                />
              ))}
            </div>
          </>
        )}
      </div>
    </div>
  );
}

function ImageCard({ img, index, onDelete, onReplace, onDragStart, onDrop }) {
  const [hover, setHover] = useState(false);
  const [dragging, setDragging] = useState(false);

  return (
    <div
      style={c.imgCard(dragging)}
      draggable
      onDragStart={() => { setDragging(true); onDragStart(); }}
      onDragEnd={() => setDragging(false)}
      onDragOver={e => e.preventDefault()}
      onDrop={() => { setDragging(false); onDrop(); }}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
    >
      <img src={img.url} alt="" style={c.imgEl} />
      <div style={{ ...c.imgOver, opacity: hover ? 1 : 0 }}>
        <button onClick={onReplace} style={{ ...c.btn('ghost'), fontSize: '0.75rem', padding: '0.35rem 0.8rem' }}>Replace</button>
        <button onClick={onDelete}  style={{ ...c.btn('danger'), fontSize: '0.75rem', padding: '0.35rem 0.8rem' }}>Delete</button>
      </div>
      <div style={c.tag}>#{index + 1} · {img.filename.length > 18 ? img.filename.slice(0, 16) + '…' : img.filename}</div>
    </div>
  );
}

function StaticImageCard({ path, index, onDelete }) {
  const [hover, setHover] = useState(false);
  const filename = path.split('/').pop();

  // Prefer API endpoint in local development since Flask backend is running.
  // In production, fallback gracefully between API and FRONTEND host.
  const isLocal = !FRONTEND || FRONTEND.includes('localhost') || FRONTEND.includes('127.0.0.1');
  const primarySrc = isLocal
    ? `${API}/public-images/${filename}`
    : `${FRONTEND}/images/${filename}`;
  const fallbackSrc = isLocal
    ? `${FRONTEND}/images/${filename}`
    : `${API}/public-images/${filename}`;

  const [src, setSrc] = useState(primarySrc);

  useEffect(() => {
    setSrc(primarySrc);
  }, [primarySrc]);

  return (
    <div
      style={{ ...c.imgCard(false), cursor: 'default', border: '1px dashed #2A3445' }}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
    >
      <img
        src={src}
        alt=""
        style={c.imgEl}
        onError={() => {
          if (src !== fallbackSrc) {
            setSrc(fallbackSrc);
          }
        }}
      />
      <div style={{ ...c.imgOver, opacity: hover ? 1 : 0 }}>
        <button onClick={() => window.open(src, '_blank')} style={{ ...c.btn('ghost'), fontSize: '0.75rem', padding: '0.35rem 0.8rem' }}>View</button>
        <button onClick={onDelete} style={{ ...c.btn('danger'), fontSize: '0.75rem', padding: '0.35rem 0.8rem' }}>Delete</button>
      </div>
      <div style={c.tag}>#{index + 1} · {filename.length > 18 ? filename.slice(0, 16) + '…' : filename}</div>
    </div>
  );
}

/* ══════════════════════════════════════════════════════════════════════════════
   ROOT APP
══════════════════════════════════════════════════════════════════════════════ */
export default function App() {
  const [tab, setTab] = useState('images');

  return (
    <div style={c.wrap}>
      <div style={c.header}>
        <div style={c.brand}>
          <img src="/eazyworld_logo.png" alt="Eazyworld EHS Engineering" style={c.logo} />
          <div style={c.brandName}>
            <p style={c.brandTitle}>EAZYWORLD</p>
            <p style={c.brandSub}>EHS Engineering</p>
          </div>
        </div>
        <div style={{ color: '#6B7280', fontSize: '0.72rem', letterSpacing: '2px', textTransform: 'uppercase' }}>Admin Panel</div>
      </div>

      <div style={c.nav}>
        <button style={c.navBtn(tab === 'images')}       onClick={() => setTab('images')}>🖼 Image Management</button>
        <button style={c.navBtn(tab === 'inspections')}  onClick={() => setTab('inspections')}>📋 Inspection Requests</button>
        <button style={c.navBtn(tab === 'stats')}        onClick={() => setTab('stats')}>📊 Training Stats</button>
      </div>

      {tab === 'images' ? <ImagePanel /> : tab === 'inspections' ? <InspectionsPanel /> : <StatsPanel />}
    </div>
  );
}
